import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthGuard {
  constructor(
    public authService: AuthService,
    public router: Router,
  ) {}
  canActivate() {
    const user = this.authService.userSignal();
    if (user) {
      return true;
    } else {
      this.router.navigateByUrl("/auth/login");
      return false;
    }
  }
}
